import { render, staticRenderFns } from "./CreatingSurveys.vue?vue&type=template&id=08ba2a8a"
import script from "./CreatingSurveys.vue?vue&type=script&lang=js"
export * from "./CreatingSurveys.vue?vue&type=script&lang=js"
import style0 from "./CreatingSurveys.vue?vue&type=style&index=0&id=08ba2a8a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports